export default __webpack_public_path__ + "static/head-nav-active-yellow-be145f20ee88cf9b4ce18a11c3052f80.png";